<template>
  <ModalBase :show-modal="true" @close-modal="close" :loading="loading" :short="true" :narrow="true" :overlay-scrollb="true" class="dashboard-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          <div v-if="modalObject.title">
            {{ modalObject.title }}
          </div>
          <div v-else>
            <div class="dashboard-modal--title" v-html="modalContent.title" />
            <div class="dashboard-modal--entrydata">
              <div class="dashboard-modal--entrydata__item">
                <div>{{ modalObject.user_name }}<span class="sub-separator" />{{ getTime() }}</div>
              </div>
            </div>
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="customBody">
        <div>
          <dl class="gk-modal-description-list">
            <div v-for="(descItem, index) in descriptionItems" :key="index" class="gk-modal-description-list--item" :class="[descItem.type]">
              <dt v-if="descItem.label" class="gk-modal-description-list--item__label">
                {{ descItem.label }}
              </dt>
              <dd v-if="!descItem.type" class="gk-modal-description-list--item__value" :class="{ 'empty-value': !descItem.value }" v-html="(descItem.value) ? descItem.value : 'empty'" />
              <dd v-if="descItem.type === 'company_picker'" class="gk-modal-description-list--item__value">
                <b-form-select v-model="selectedAccountantCompany" :options="companyPickerOptions" size="sm" />
              </dd>
              <dd v-if="descItem.type === 'list'" class="gk-modal-description-list--item__value">
                <ul role="list" class="item__value--list">
                  <li v-for="(descSubItem, subIndex) in descItem.value" :key="index + '-' + subIndex">
                    <div class="listitem-wrap">
                      <template v-for="(rowItem, subRowIndex) in descSubItem" >
                        <svg v-if="rowItem.icon && rowItem.icon === 'success'" :key="index + '-' + subIndex + '-' + subRowIndex" class="listitem-icon" :class="[rowItem.icon]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <svg v-if="rowItem.icon && rowItem.icon === 'failed'" :key="index + '-' + subIndex + '-' + subRowIndex" class="listitem-icon" :class="[rowItem.icon]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <div v-if="!rowItem.icon" :key="index + '-' + subIndex + '-' + subRowIndex" class="listitem-text" :class="[rowItem.class]">
                          {{ rowItem.value }}
                        </div>
                      </template>
                    </div>
                  </li>
                </ul>
              </dd>
              <dd v-if="descItem.type === 'disclaimer'" class="gk-modal-description-list--item__value">
                <p>{{ descItem.value }}</p>
              </dd>
            </div>
          </dl>
        </div>  
      </div>
      <div v-else v-html="modalContent.body" :class="[modalObject.object_type]"/>
    </template>
    <template v-slot:actions>
      <div v-if="actionItems" class="dashboard-modal-actions">
        <template v-for="(actItem, index) in actionItems">
          <a v-if="!actItem.button" class="text-blue" :key="index" :href="actItem.link">{{ actItem.text }}</a>
          <button v-else :key="index" @click="callFn(actItem.fn)" class="btn" :class="['btn-' + ((actItem.variant) ? actItem.variant : 'primary')]">{{ actItem.text }}</button>
        </template>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import CompanyPicker from "@/components/CompanyPicker";
import moment from 'moment';
export default {
  name: 'DashboardModal',
  components: {
    ModalBase, TitleBar, CompanyPicker
  },
  props: {

  },
  data() {
    return {
      customBody: false,
      descriptionItems: null,
      actionItems: null,
      selectedAccountantCompany: null,
      loading: false,
      modalContent: {
        pretitle: null,
        title: null,
        body: null,
        actions: null
      }
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: 'main/getCurrentCompany',
      modalObject: 'dashboard/getModalContent',
      availableCompanies: 'main/getAvailableCompanies',
      getGekkoNotification: 'notifications/getGekkoNotification',
      preferredLanguage: 'main/getPreferredLanguage',
      getCompanyId: 'main/getCompanyId'
    }),
    addCompanyLink () {
      return window.Urls["accounts_add_company"]() + "?next=" + this.$router.currentRoute.path
    },
    companyPickerOptions () {
      let options = []
      this.availableCompanies.profile_companies.forEach(item => {
        if (item.id == this.getCompanyId) this.selectedAccountantCompany = item.id
        options.push({ value: item.id, text: item.name })
      });
      return options
    }
  },
  mounted () {
    this.modalContent.pretitle = this.getPretitle()
    this.modalContent.title = this.getTitle()

    if (this.modalObject.title) {
      this.modalContent.title = this.modalObject.title
    } 
    
    this.getContent()
  },
  methods: {
    ...mapActions({ 
      loadNotificationTemplate: "notifications/loadNotificationTemplate",
      loadPayment: 'timeline/loadPayment',
      loadCost: 'timeline/loadCost',
      loadTrip: 'timeline/loadTrip',
      loadContact: 'timeline/loadContact',
      loadQuotation: 'timeline/loadQuotation',
      loadInvoice: 'timeline/loadInvoice',
      loadCorrection: 'timeline/loadCorrection',
      loadEmailReport: 'timeline/loadEmailReport',
      loadCurrentCompany: 'main/loadCurrentCompany',
      loadUserCompanies: 'main/loadUserCompanies',
      emailIgnoreFailure: 'timeline/emailIgnoreFailure',
      acceptInvitation: "notifications/acceptInvite",
      rejectInvitation: "notifications/rejectInvite",
      acceptAccountantInvitation: "notifications/acceptAccountantInvite",
      rejectAccountantInvitation: "notifications/rejectAccountantInvite",
      getFreelancerInvite: "notifications/getFreelancerInvite",
      getAccountantCommunication: 'accountants/getAccountantCommunication',
      loadAccountantWidget: 'dashboard/loadAccountantWidget'
    }),
    ...mapMutations({ 
      addStoreWidget: 'dashboard/ADD_WIDGET',
      setCurrentCompany: 'main/SET_CURRENT_COMPANY',
      setHasAccountant: 'dashboard/SET_HAS_ACCOUNTANT'
    }),
    callFn (fName) {
      this[fName]()
    },
    close () {
      this.$store.dispatch('dashboard/closeModal')
    },
    getTime () {
      const time = new Date(this.modalObject.event_time).toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' })
      return moment(new Date(this.modalObject.event_time)).format('MMM DD YYYY') + ' ' + this.$gettext('at') + ' ' + time
    },
    getPretitle () {
      return (this.modalObject.object_type === 'gekko_notification') ? this.$gettext('NOTIFICATION'): this.modalObject.object_type + ' ' + this.$gettext('TIMELINE ENTRY')
    },
    getTitle () {
      const title = this.modalObject.grammar
                      .replace('%user', this.modalObject.user_name)
                      .replace('%object_type_name', '<span class="object-typename">' + this.modalObject.object_type_name + '</span>')
                      .replace('%object_name', ' <span class="object-name ' + this.modalObject.object_type + '">' + this.modalObject.object_name + '</span>')

      return title
    },
    parseItemUrl (url, type) {
      let parsedUrl = url
      if(type === 'cost' || type === 'trip') {
        parsedUrl = parsedUrl.replace('/view/', '/edit/')
      }
      if(type === 'invoice') {
        parsedUrl = '/' + this.preferredLanguage + parsedUrl.slice(3)
      }
      return parsedUrl
    },
    getContent () {
      if(this.modalObject[this.modalObject.object_type] || this.modalObject.object_type === "correction" || this.modalObject.object_type === "accountant_comm") {
        // 'accountant_comm' exception because object_type can only have 20 chars max
        switch (this.modalObject.object_type) {

          case 'accountant_comm':
            this.getCommunicationContent()
            break;

          case 'gekko_notification':
            this.getNotificationContent()
            break;

          case 'accountant_invite':
            this.getReceivedAccountantInviteData()
            break;

          case 'team_invite':
            this.getReceivedInviteData()
            break;

          case 'cost':
            this.getCostData()
            break;

          case 'invoice':
            if (this.modalObject.email_message) {
              this.getInvoiceEmailReport()
            } else {
              this.getInvoiceData()
            }
            break;
          
          case 'correction':
            this.getCorrectionData()
            break;

          case 'trip':
            this.getTripData()
            break;

          case 'contact':
            this.getContactData()
            break;

          case 'quotation':
            if (this.modalObject.email_message) {
              this.getInvoiceEmailReport()
            } else {
              this.getQuotationData()
            }
            break;
            
          default:
            this.modalContent.body = this.$gettext('There is no preview data for this item.')
            break;
        }
      } else if (this.modalObject.object_type === 'team_invite' || this.modalObject.object_type === 'accountant_invite') {
        this.getSentInviteData()
      } else {
        if (this.modalObject.object_type === 'invoice_payment') {
          this.getInvoicePaymentData()
        } else {
          this.modalContent.body = this.$gettext('This item is no longer available.')
          this.$store.dispatch("dashboard/closeModal")
        }
      }
    },
    getInvoicePaymentData () {
      this.loadPayment(this.modalObject['payment']).then((response) => {
        this.customBody = true
        this.descriptionItems = []
        this.descriptionItems.push({ label: this.$gettext('Payment type'), value: response.data.get_payment_type_display })
        this.descriptionItems.push({ label: this.$gettext('Date'), value: response.data.payment_date })
        this.descriptionItems.push({ label: this.$gettext('Amount'), value: this.$options.filters.formatNumber(response.data.amount) + ' €' })
        this.descriptionItems.push({ label: this.$gettext('Description'), value: response.data.description })

        this.actionItems = []
        this.actionItems.push({ text: this.$gettext('View payment'), link: this.modalObject.url })
      })
    },
    getSentInviteData () {
      this.customBody = true
      this.descriptionItems = []
      if (this.modalObject.object_type === 'team_invite') {
        this.descriptionItems.push({ label: this.$gettext('Recipient'), value: this.modalObject.object_name })
      } else {
        this.descriptionItems.push({ label: this.$gettext('Sent by'), value: this.modalObject.user_name })
      }
      this.descriptionItems.push({ label: this.$gettext('Date'), value: moment(new Date(this.modalObject.event_time)).format('MMM DD YYYY') })
      let status = ''
      switch (this.modalObject.grammar_type) {
        case 'sent_invite_pending':
          status = this.$gettext('Pending')
          break;
        case 'invite_accepted':
        case 'sent_invite_accepted':
          status = this.$gettext('Accepted')
          break;
        case 'invite_rejected':
        case 'sent_invite_rejected':
          status = this.$gettext('Rejected')
          break;
        case 'team_member_disconnected':
          status = this.$gettext('Disconnected')
          break;
      }
      this.descriptionItems.push({ label: this.$gettext('Status'), value: status })
    },
    getReceivedAccountantInviteData () {
      if (this.modalObject.object_type in this.modalObject && this.modalObject[this.modalObject.object_type]) {
        this.getFreelancerInvite(this.modalObject[this.modalObject.object_type]).then((response) => {
          this.modalContent.freelancer_id = response.data.accountant
          this.customBody = true
          this.descriptionItems = []
          this.descriptionItems.push({ label: this.$gettext('Sent by'), value: this.modalObject.user_name })
          this.descriptionItems.push({ label: this.$gettext('Date'), value: moment(new Date(this.modalObject.event_time)).format('MMM DD YYYY') })
          this.descriptionItems.push({ label: this.$gettext('Status'), value: response.data.status === 'pending' ? this.$gettext('Pending') : response.data.status === 'accepted' ? this.$gettext('Accepted') : this.$gettext('Rejected') })

          if (response.data.status === 'pending') {
            this.descriptionItems.push({ label: this.$gettext('Assigned company'), type: 'company_picker' })
            this.descriptionItems.push({ label: '', type: 'disclaimer', value: this.$gettext('By accepting this invite you will give access to the accountant to see and change all data of your company.') })

            this.actionItems = []
            this.actionItems.push({ text: this.$gettext('Accept invitation'), button: true, fn: 'acceptAccountantInvite' })
            this.actionItems.push({ text: this.$gettext('Reject'), button: true, variant: 'danger', fn: 'rejectAccountantInvite' })
          } else {
            this.descriptionItems.push({ label: this.$gettext('Assigned company'), value: response.data.accountant_connection?.customer?.name || '' })
          }
        })
      } else {
        this.modalContent.body = `<span style='color: #b73f3f'>${this.$gettext('Accountant invite not found or expired')}</span>`;
      }
    },
    getReceivedInviteData () {
      this.customBody = true
      this.descriptionItems = []
      this.descriptionItems.push({ label: this.$gettext('Recipient'), value: this.modalObject.object_name })
      this.descriptionItems.push({ label: this.$gettext('Date'), value: moment(new Date(this.modalObject.event_time)).format('MMM DD YYYY') })
      this.descriptionItems.push({ label: this.$gettext('Status'), value: this.modalObject.status === 'unseen' ? this.$gettext('Pending') : this.$gettext('Settled') })
      
      this.actionItems = []
      if (this.modalObject.type === 'notification') {
        this.actionItems.push({ text: this.$gettext('Accept invitation'), button: true, fn: 'acceptInvite' })
        this.actionItems.push({ text: this.$gettext('Reject'), button: true, variant: 'danger', fn: 'rejectInvite' })
      } else {
        if (this.modalObject.url && this.modalObject.url.length > 0) {
          this.actionItems.push({ text: this.$gettext('View and edit'), link: this.modalObject.url })
        }
      }
    },
    getCostData () {
      this.loadCost(this.modalObject[this.modalObject.object_type]).then((response) => {
        this.customBody = true
        this.descriptionItems = []
        this.descriptionItems.push({ label: this.$gettext('Number on document'), value: response.data.number_on_document })
        this.descriptionItems.push({ label: this.$gettext('Date'), value: response.data.date })
        this.descriptionItems.push({ label: this.$gettext('Amount'), value: this.$options.filters.formatNumber(response.data.amount) + ' €' })
        this.descriptionItems.push({ label: this.$gettext('Customer'), value: response.data.customer?.name })
        this.descriptionItems.push({ label: this.$gettext('Subtotal'), value: this.$options.filters.formatNumber(response.data.subtotal_amount) + ' €' })
        this.descriptionItems.push({ label: this.$gettext('Total Tax.'), value: this.$options.filters.formatNumber(response.data.total_tax) + ' €' })
        this.descriptionItems.push({ label: this.$gettext('Description'), value: response.data.description })

        if (response.data.missing_attributes.length > 0) {
          this.descriptionItems.push({ label: this.$gettext('Missing fields'), value: response.data.missing_attributes.join(', ') })
        }

        this.actionItems = []
        this.actionItems.push({ text: this.$gettext('View and edit'), link: this.parseItemUrl(this.modalObject.url, this.modalObject.object_type) })
        // this.actionItems.push({ text: this.$gettext('Go to invoice'), link: '/invoices/#/send/' + this.modalObject['email_message'] + '/' })
      })
    },
    getTripData () {
      this.loadTrip(this.modalObject[this.modalObject.object_type]).then((response) => {
        this.customBody = true
        this.descriptionItems = []
        this.descriptionItems.push({ label: this.$gettext('Number'), value: response.data.number })
        this.descriptionItems.push({ label: this.$gettext('Date'), value: moment(new Date(response.data.date)).format('MMM DD YYYY') })
        this.descriptionItems.push({ label: this.$gettext('From'), value: response.data.start.city + ' (' + response.data.start.country_display + ')' })
        this.descriptionItems.push({ label: this.$gettext('To'), value: response.data.end.city + ' (' + response.data.end.country_display + ')' })
        this.descriptionItems.push({ label: this.$gettext('Total distance'), value: response.data.total_distance + ' KM' })
        this.descriptionItems.push({ label: this.$gettext('End Odometer'), value: response.data.end_odometer + ' KM' })
        this.descriptionItems.push({ label: this.$gettext('Total hours'), value: response.data.total_hours })

        this.actionItems = []
        this.actionItems.push({ text: this.$gettext('View and edit'), link: this.parseItemUrl(this.modalObject.url, this.modalObject.object_type) })
      })
    },
    getContactData () {
      this.loadContact(this.modalObject[this.modalObject.object_type]).then((response) => {
        this.customBody = true
        this.descriptionItems = []
        this.descriptionItems.push({ label: this.$gettext('Name'), value: response.data.name })
        this.descriptionItems.push({ label: this.$gettext('Phone Number'), value: response.data.phone_number })
        this.descriptionItems.push({ label: this.$gettext('Address'), value: response.data.address })
        this.descriptionItems.push({ label: this.$gettext('Postal code'), value: response.data.postal_code })
        this.descriptionItems.push({ label: this.$gettext('Kvk'), value: response.data.kvk })
        this.descriptionItems.push({ label: this.$gettext('Type'), value: ((response.data.is_supplier) ? 'supplier' : '') + '' + ((response.data.is_customer) ? ((response.data.is_supplier) ? ', ' : '') + 'customer' : '') })

        this.actionItems = []
        this.actionItems.push({ text: this.$gettext('View and edit'), link: this.parseItemUrl(this.modalObject.url, this.modalObject.object_type) })
      })
    },
    getQuotationData () {
      this.loadQuotation(this.modalObject[this.modalObject.object_type]).then((response) => {
        this.customBody = true
        this.setInvoiceData(response)
      })
    },
    getInvoiceData () {
      this.loadInvoice(this.modalObject[this.modalObject.object_type]).then((response) => {
        this.customBody = true
        this.setInvoiceData(response)
      })
    },
    getCorrectionData (){
      this.loadCorrection(this.modalObject.invoice).then((response) => {
        this.customBody = true
        delete response.data.number
        this.setInvoiceData(response)
      })
    },
    setInvoiceData (response) {
      this.descriptionItems = []
      if(response.data.number){
        this.descriptionItems.push({ label: this.$gettext('Number'), value: response.data.number })
      }
      this.descriptionItems.push({ label: this.$gettext('Amount'), value: this.$options.filters.formatNumber(response.data.currency_total_amount) + ' €' })
      this.descriptionItems.push({ label: this.$gettext('Customer'), value: response.data.recipient_customer.name })
      this.descriptionItems.push({ label: this.$gettext('Date'), value: response.data.invoice_date })
      this.descriptionItems.push({ label: this.$gettext('Due date'), value: response.data.due_date })
      this.descriptionItems.push({ label: this.$gettext('Status'), value: response.data.display_status.display_status })
      this.descriptionItems.push({ label: this.$gettext('Sent date'), value: (response.data.sent_date) ? moment(new Date(response.data.sent_date)).format('MMM DD YYYY') : '' })
      this.descriptionItems.push({ label: this.$gettext('Message'), value: response.data.message })
      
      const linesKey = (this.modalObject.object_type === 'invoice' || this.modalObject.object_type === 'correction') ? 'invoice_lines' : 'quotationline_set'
      const sublistItems = []
      response.data[linesKey].forEach(subItem => {
        sublistItems.push([
          { label: this.$gettext('amount'), value: subItem.multiplier + ' x ' + this.$options.filters.formatNumber(subItem.amount) + ' €' },
          { label: this.$gettext('description'), value: subItem.description, class: 'truncate' }
        ])
      });
      this.descriptionItems.push({ label: this.$gettext('Lines'), value: sublistItems, type: 'list'})

      this.actionItems = []
      this.actionItems.push({ text: this.$gettext('View and edit'), link: this.parseItemUrl(this.modalObject.url, this.modalObject.object_type) })
    },
    getInvoiceEmailReport () {
      this.loading = true
      this.loadEmailReport(this.modalObject['email_message']).then((response) => {
        this.customBody = true

        const status = (response.data.forced_status) ? response.data.forced_status : response.data.status
        let overriden_status = ''
        if (response.data.forced_status) {
          overriden_status = ' (' + this.$gettext('overridden') + ')'
        }

        this.descriptionItems = []
        this.descriptionItems.push({ label: this.$gettext('Subject'), value: response.data.subject })
        this.descriptionItems.push({ label: this.$gettext('Status'), value: '<span class="' + status + '">' + status + overriden_status + "</span>" })
        this.descriptionItems.push({ label: this.$gettext('Recipients'), value: response.data.recipients })
        this.descriptionItems.push({ label: this.$gettext('Message'), value: response.data.message })

        const sublistItems = []
        response.data.emaileventlog_set.forEach(subItem => {
          sublistItems.push([
            { icon: (subItem.event === 'delivered') ? 'success' : 'failed' },
            { label: this.$gettext('recipient'), value: subItem.recipient },
            { label: this.$gettext('reason'), value: (subItem.event === 'delivered') ? '' : '(' + subItem.reason + ')' }
          ])
        });
        this.descriptionItems.push({ label: this.$gettext('Event log'), value: (sublistItems.length > 0) ? sublistItems : '', type: 'list' })

        this.actionItems = []
        if (response.data.status === 'failed' && !response.data.forced_status) {
          this.actionItems.push({ text: this.$gettext('Ignore failure'), button: true, fn: 'ignoreFailure' })
        }
        this.actionItems.push({ text: this.$gettext('Go to invoice'), link: this.parseItemUrl(this.modalObject.url, this.modalObject.object_type) })
        this.loading = false
      })
    },
    ignoreFailure () {
      this.loading = true
      this.emailIgnoreFailure(this.modalObject['email_message']).then(() => {
        this.$store.commit('setAlert', {
          title: this.$gettext('Email report'),
          text: this.$gettext('Delivery status marked as success'),
          variant: 'primary',
          duration: 4
        }, { root: true })
        this.getInvoiceEmailReport()
      })
    },
    getCommunicationContent () {
      this.getAccountantCommunication(this.modalObject.accountant_communication).then((response) => {
        this.communicationContent = response.data
        this.modalContent.title = this.communicationContent.subject
        this.modalContent.body = this.communicationContent.message
      })
    },
    getNotificationContent () {
      this.notificationContent = this.getGekkoNotification(this.modalObject[this.modalObject.object_type])
      if (!this.notificationContent) {
        this.loadNotificationTemplate(this.modalObject[this.modalObject.object_type]).then((response) => {
          this.notificationContent = response
          this.modalContent.title = this.notificationContent.title
          this.modalContent.body = this.notificationContent.body
        })
      } else {
        this.modalContent.title = this.notificationContent.title
        this.modalContent.body = this.notificationContent.body
      }
    },
    acceptInvite () {
      const payload = {
        user_name: this.modalObject.user_name,
        company_name: this.modalObject.object_name,
        invite_id: this.modalObject[this.modalObject.object_type],
        invite_code: this.modalObject.invite_code
      }
      this.acceptInvitation(payload).then(() => {
        this.loadUserCompanies()
        this.close()
      })
    },
    rejectInvite () {
      const payload = {
        user_name: this.modalObject.user_name,
        company_name: this.modalObject.object_name,
        invite_id: this.modalObject[this.modalObject.object_type],
        invite_code: this.modalObject.invite_code
      }
      this.rejectInvitation(payload).then(() => {
        this.close()
      })
    },
    acceptAccountantInvite () {
      if(!this.selectedAccountantCompany) {
        this.$store.commit('setAlert', {
          title: this.$gettext('Company needed'),
          text: this.$gettext('You need to select one company to accept this request.'),
          variant: "warning",
          duration: 4
        });
      } else {
        const payload = {
          user_name: this.modalObject.user_name,
          invite_id: this.modalObject[this.modalObject.object_type],
          params: {
            customer: this.selectedAccountantCompany,
            accountant: this.modalContent.freelancer_id
          }
        }
        this.acceptAccountantInvitation(payload).then((response) => {
          this.close();
          
          let newValues = {
            has_accountant: true,
            accountant_branding: {
              id: payload.params.accountant,
              color: response.data.color
            }
          }
          let company = this.currentCompany;

          company = Object.assign(company, newValues);
          
          this.setCurrentCompany(company);
          this.setHasAccountant(true);

          this.loadAccountantWidget()
        }).catch((error) => {
          this.close();
          let msg = this.$gettext('There was an error accepting the accountant invitation');
          if (error.status === 402) {
            msg = this.$gettext('Your accountant must upgrade their premium plan before you can accept this invitation.');
          } else if (error.status === 400 && 'non_field_errors' in error.data) {
            msg = this.$gettext('You are already connected to this accountant with this company. Try a different company.');
          } else if (error.status === 409) {
            msg = error.data.detail || msg;
          }

          this.$store.commit('setAlert', {
            title: this.$gettext('Connection rejected'),
            text: msg,
            variant: "danger",
            duration: 4
          });
        })
      }

    },
    rejectAccountantInvite () {
      const payload = {
        user_name: this.modalObject.user_name,
        invite_id: this.modalObject[this.modalObject.object_type]
      }
      this.rejectAccountantInvitation(payload).then(() => {
        this.close()
      })
    },
  }
}
</script>

<style lang="scss">
  .gk-modal-description-list {
    padding: 0; margin: 0;
    &--item {
      padding-top: 1rem;
      padding-bottom: 1rem;
      display: grid;
      grid-template-columns: repeat(3,minmax(0,1fr));
      gap: 1rem;
      font-size: 16px;
      &__label {
        color: rgb(107, 114, 128);
        font-family: DINNextLTPro-Medium;
        font-weight: normal;
        line-height: 1.2;
      }
      &__value {
        grid-column: span 2/span 2;
        margin: 0;
        font-family: DINNextLTPro-Regular;
        color: rgb(17, 24, 39);
        line-height: 1.2;
        &.empty-value { color: #dadada; }
        .item__value--list {
          margin: 0; padding: 0; list-style: none;
          border: 1px solid $colorBorderDash;
          border-radius: 6px;
          li {
            padding: 0.75rem;
            padding-right: 1rem;
            display: flex;
            align-items: center;
            &:not(:first-child) {
              border-top: 1px solid $colorBorderDash;
            }
            .listitem-wrap {
              width: 0;
              flex: 1 1 0%;
              display: flex;
              align-items: center;
              font-size: 14px;
              line-height: 1.2;
              .listitem-icon {
                flex-shrink: 0;
                width: 1.25rem;
                height: 1.25rem;
                margin-right: 10px;
                border-radius: 24px;
                padding: 3px;
                &.failed {
                  background: #fcb8b8;
                }
                &.success {
                  background: #9ce2b5;
                }
              }
              .listitem-text {
                white-space: nowrap;
                &:not(:last-child) { margin-right: 10px; }
                &.truncate {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
      border-top: 1px solid $colorBorderDash;
      &.company_picker {
        .gk-modal-description-list--item__label {
          display: flex;
          align-items: center;
        }
      }
      &.disclaimer {
        .gk-modal-description-list--item__value {
          font-size: 14px;
          text-align: center; 
          color: #adadad;
          grid-column: span 3/span 3;
        }
      }
    }
  }

  .dashboard-modal {
    z-index: 9999;
    .gk-modal {
      padding: 0rem;
      .gk-modal-content {
        .close-btn {
          top: -6px;
          right: -6px;
          @media (min-width: 576px) {
            top: -10px;
            right: -10px;
          }
        }
      }
    }
    .os-content {
      padding: 1rem !important;
    }
    .titlebar.title-modal--simple {
      margin-bottom: 0px;
      padding: 1rem;
    }
    .accountant_comm {
      white-space: pre-line;
      padding-bottom: 1rem;
    }
    &--pretitle {
      font-size: 14px;
      color: #cecece;
      font-weight: lighter;
      font-family: DINNextLTPro-Regular;
      line-height: 1;
      margin-bottom: 7px;
      text-transform: uppercase;
    }
    &--title {
      line-height: 1;
      font-size: 26px;
      &:first-letter {
        text-transform: capitalize;
      }
      .object-grammar {
        text-transform: capitalize;
      }
      .object-typename {
        text-transform: lowercase;
      }
      .object-name {
        &.invoice {
          color: $colorAppInvoices;
        }
        &.cost {
          color: $colorAppCosts;
        }
      }
    }
    &--entrydata {
      margin-top: 7px;
      display: flex;
      align-items: center;
      font-size: 14px; 
      font-family: DINNextLTPro-Regular;
      color: #adadad;
      &__item {
        display: flex;
        align-items: center;
        line-height: 1;
      }
      .sub-separator {
        position:relative;
        padding: 0px 7px;
        &:before {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: $radiusSm;
          background: currentColor;
          position: absolute;
          top: 50%;
          left: 5px;
        }
      }
    }
    .modal-content-wrap {
      height: 100% !important;
      background: #f7fafb;
      &:not(.has-actions) {
        border-radius: 0px 0px $radiusLg $radiusLg;
      }
    }

    .action-buttons-wrapper.has-actions {
      padding: 1.5rem;
      line-height: 1;
    }
    
    .dashboard-modal-actions {
      font-size: 16px;
      display: flex;
      width: 100%;
      justify-content: center;
      align-content: center;
      > a { display: flex; align-items: center; }
      > * {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
    .gk-modal-description-list {
      &--item {
        &__value {
          .failed {
            color: #963233;
          }
          .success {
            color: #1a743b;
          }
        }
      }
    }
  }


</style>
